import React from 'react';
import logo from './logo.svg';
import { Box, Grid, Typography, useTheme, TextField, Select, MenuItem, Button } from '@mui/material';
import ControlPanel from './ControlPanel';
import { ControlPanelProvider } from './ControlPanel/ControlPanelProvider';

function App() {

  return (
    <Box>
      <ControlPanelProvider>
        <ControlPanel />
      </ControlPanelProvider>
    </Box>
  );
}

export default App;
